import { render, staticRenderFns } from "./IconSorting.vue?vue&type=template&id=ba6566f4"
import script from "./IconSorting.vue?vue&type=script&lang=js"
export * from "./IconSorting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports